import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const helpCenterSlice = createSlice({
  name: "helpCenterArticles",
  initialState,
  reducers: {
    setHelpCenterArticles: (state, action) => {
      return action.payload;
    },
  },
});

export const { setHelpCenterArticles } = helpCenterSlice.actions;
export default helpCenterSlice.reducer;
